import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Reimbursement } from '../Models/Reimbursement';
import { BasicSearchRequest } from '../Models/BasicSearchRequest';

class ReimbursementApi {
  static getReimbursement(id: string) {
    return axios.get<Reimbursement>(
      `${API_URL}/api/user/reimbursement/${id}`,
      getAuthHeader()
    );
  }
  static getUserLatestReimbursement(id: number) {
    return axios.get<Reimbursement>(
      `${API_URL}/api/user/reimbursement/user/${id}/latest`,
      getAuthHeader()
    );
  }
  static getReimbursementList(request: BasicSearchRequest) {
    return axios.post<Reimbursement[]>(
      `${API_URL}/api/user/reimbursement/list`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateReimbursement(request: Reimbursement) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/reimbursement`,
      request,
      getAuthHeader()
    );
  }
  static uploadReimbursementImage(request: FormData) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/user/reimbursement/image/upload`,
      request,
      getAuthHeader()
    );
  }
}

export default ReimbursementApi;
